import React, { PureComponent } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Radium from 'radium';
import * as keyboardEventHelpers from 'globals/keyboardEvents';

import { connectMotion } from 'shared/kanimate';
import { StylePropType } from 'globals/styles';

import { start, end, tween, staticStyles, staticStylesRTL, startRTL } from './styles';
import ChatConversation from '../../conversation/ChatConversation';
import ChatForm from '../../form/ChatForm';
import ChatHistory from '../../history/ChatHistory';
import Footer from '../Footer';

import { handleFirstChatRoute } from './actions_routing';
import { decideDisplay, setFocus } from './actions';
import { getCurrentChatRoute, getCompanyShowBrandingIdentifier, getFocus } from './selectors';

export class ChatApp extends PureComponent {
  constructor(props) {
    super(props);
    this.pollerBH = null;
    this.chatAppWrapper = null;
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.handleDisplay();
  }

  componentDidMount() {
    this.props.initRoute();
    this.initPollerBH();
  }

  componentDidUpdate() {
    const { elInFocus } = this.props;

    if (elInFocus === 'firstFocusableElement') {
      this.chatAppWrapper.focus();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.pollerBH);
  }

  initPollerBH = () => {
    if (this.pollerBH) clearTimeout(this.pollerBH);
    this.pollerBH = setTimeout(() => {
      this.props.handleDisplay();
      return this.initPollerBH();
    }, 3000);
  };

  handleKeyDown = event => {
    const { focusOn } = this.props;

    const activeElementId = get(document, 'activeElement.id');

    const isFirstFocusableElement = activeElementId === 'firstFocusableElement';
    const isLastFocusableElement = activeElementId === 'lastFocusableElement';
    const shiftKeyPressed = get(event, 'shiftKey');

    if (keyboardEventHelpers.isTabKey(event) && shiftKeyPressed && isFirstFocusableElement) {
      event.preventDefault();
      focusOn('lastFocusableElement');
    } else if (keyboardEventHelpers.isTabKey(event) && !shiftKeyPressed && isLastFocusableElement) {
      event.preventDefault();
      focusOn('firstFocusableElement');
    } else {
      focusOn('');
    }
  };

  renderRoute() {
    const { chatRoute } = this.props;
    switch (chatRoute) {
      case 'conversation':
        return <ChatConversation />;
      case 'form':
        return <ChatForm />;
      case 'history':
        return <ChatHistory />;
      default:
        return null;
    }
  }

  renderFooter() {
    const { showBrandingIdentifier } = this.props;
    if (!showBrandingIdentifier) return null;
    return <Footer />;
  }

  render() {
    const { styles } = this.props;

    return (
      <div className="chatAppWrapper kustomer-app-container" style={styles.wrapper}>
        <div
          id="firstFocusableElement"
          ref={element => (this.chatAppWrapper = element)}
          tabIndex="0"
          onKeyDown={this.handleKeyDown}
          key="border"
          className="kustomer-app"
          style={styles.border}
        >
          {this.renderRoute()}
          {this.renderFooter()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    chatRoute: getCurrentChatRoute(state),
    showBrandingIdentifier: getCompanyShowBrandingIdentifier(state),
    elInFocus: getFocus(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    initRoute: () => {
      dispatch(handleFirstChatRoute());
    },
    handleDisplay: () => {
      dispatch(decideDisplay());
    },
    focusOn: element => {
      dispatch(setFocus(element));
    },
  };
};

ChatApp.propTypes = {
  chatRoute: PropTypes.string,
  showBrandingIdentifier: PropTypes.bool,
  styles: StylePropType,
  initRoute: PropTypes.func,
  handleDisplay: PropTypes.func,
  elInFocus: PropTypes.string.isRequired,
  focusOn: PropTypes.func.isRequired,
};

ChatApp.defaultProps = {
  chatRoute: null,
  showBrandingIdentifier: true,
  initRoute: () => {},
  handleDisplay: () => {},
  styles: {},
};

const styleConfig = {
  styles: staticStyles,
  stylesRTL: staticStylesRTL,
  start,
  startRTL,
  end,
  tween,
};

export const RadiumChatApp = Radium(ChatApp);
export const KAnimateRadiumChatApp = connectMotion(styleConfig)(RadiumChatApp);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(KAnimateRadiumChatApp);
